import { EventType, isBaptism } from 'utils/eventType';

/**
 * Left-side hero images for the auth layout (DefaultAuthLayout).
 *
 * The default is shared across every auth page. A route may override it
 * statically via `handle: { authImage }`, and runtime-driven pages — the guest
 * join page, which only learns its `eventType` after fetching the event — pick
 * a hero through AuthHeroContext + `authHeroForEventType` below.
 */
export const DEFAULT_AUTH_IMAGE = '/assets/agapae-hero.jpg';

/** Dedicated hero for a standalone baptism. */
export const BAPTISM_AUTH_IMAGE = '/assets/baptism-hero.jpg';

/**
 * Resolve the hero image for an event type, or `null` to keep the page/default
 * hero. Only a pure baptism gets a dedicated image; weddings and combined
 * wedding+baptism events keep the shared default.
 */
export const authHeroForEventType = (eventType?: EventType | null): string | null =>
  isBaptism(eventType) ? BAPTISM_AUTH_IMAGE : null;

/**
 * The concrete default hero asset for an event type. Unlike
 * `authHeroForEventType` — which returns `null` to mean "keep the layout
 * default" — this always resolves to a real URL. Used by the settings preview
 * card, which has to show the actual image a guest would see.
 */
export const defaultAuthHeroForEventType = (eventType?: EventType | null): string =>
  authHeroForEventType(eventType) ?? DEFAULT_AUTH_IMAGE;
